export const receiptEvents = {
  FRONT_GA_PAGE_VIEW: 'FRONT_GA_PAGE_VIEW',
  FRONT_LANDING_STORE_DOWNLOAD_APP: 'FRONT_LANDING_STORE_DOWNLOAD_APP',
  FRONT_LANDING_STORE_CHANGE_LANGUAGE: 'FRONT_LANDING_STORE_CHANGE_LANGUAGE',
};

class ReceiptDataLayerObject {
  constructor(action, data) {
    this.event = receiptEvents[action];
    this.data = data;
    this._clear = true;
  }
}

export class receiptDataLayer {
  push(action, data) {
    this.obj = new ReceiptDataLayerObject(action, data);
    window.dataLayer.push(this.obj);
  }
}
